import React from "react";
import { Link } from "react-router-dom";
import { trackEvent } from "../../firebase/analytics";
import Navbar from "../../components/Navbar";
import "../../styles/Blog.css";

const posts = [
  {
    slug: "why-most-employees-dont-actually-hate-their-job",
    title: "Why Most Employees Don’t Actually Hate Their Job",
    description:
      "Many employees don’t actually hate their work. They hate confusion, inconsistency, poor communication, and chaotic systems.",
    category: "Workplace Psychology",
    readTime: "6 min read",
  },
  {
    slug: "the-real-reason-employees-clock-in-late",
    title: "The Real Reason Employees Clock In Late",
    description:
      "Late clock ins are not always about laziness. Sometimes they reveal deeper problems with scheduling, communication, accountability, and workplace structure.",
    category: "Time Tracking",
    readTime: "7 min read",
  },
  {
    slug: "how-to-manage-hourly-employees",
    title: "How to Manage Hourly Employees",
    description:
      "Learn how to manage hourly employees with better scheduling, time tracking, communication, and daily workforce structure.",
    category: "Employee Management",
    readTime: "7 min read",
  },
  {
    slug: "how-to-track-employee-time",
    title: "How to Track Employee Time",
    description:
      "A practical guide to tracking employee time accurately, reducing payroll errors, and improving attendance visibility.",
    category: "Time Tracking",
    readTime: "6 min read",
  },
  {
    slug: "how-to-create-employee-schedules",
    title: "How to Create Employee Schedules",
    description:
      "Learn how to create employee schedules that improve coverage, reduce confusion, and help managers plan with more clarity.",
    category: "Scheduling",
    readTime: "7 min read",
  },
  {
    slug: "how-to-handle-leave-requests",
    title: "How to Handle Leave Requests",
    description:
      "Learn how to manage employee leave requests without creating scheduling issues, staffing gaps, or communication problems.",
    category: "Leave Management",
    readTime: "6 min read",
  },
  {
    slug: "best-way-to-manage-small-business-employees",
    title: "Best Way to Manage Small Business Employees",
    description:
      "The best way to manage small business employees is to create clear systems for scheduling, attendance, communication, and accountability.",
    category: "Operations",
    readTime: "7 min read",
  },
  {
    slug: "best-employee-management-software-for-small-businesses",
    title: "Best Employee Management Software for Small Businesses",
    description:
      "Learn what small businesses should look for in employee management software and why connected operations matter.",
    category: "Software",
    readTime: "7 min read",
  },
  {
    slug: "how-to-reduce-employee-no-shows",
    title: "How to Reduce Employee No-Shows",
    description:
      "Learn how to reduce employee no-shows with better scheduling, accountability, communication, and attendance tracking.",
    category: "Scheduling",
    readTime: "6 min read",
  },
];

const BlogPage = () => {
  return (
    <>
      <Navbar />

      <main className="blog-page">
        <section className="blog-hero">
          <span className="blog-eyebrow">Oiiko Blog</span>

          <h1>Operations, workplace psychology, and modern team management</h1>

          <p>
            Practical insights on scheduling, time tracking, workplace
            structure, employee management, and the hidden systems that shape
            how teams perform.
          </p>
        </section>

        <section className="blog-grid">
          {posts.map((post) => (
            <article key={post.slug} className="blog-card">
              <div className="blog-card-meta">
                <span>{post.category}</span>
                <span>{post.readTime}</span>
              </div>

              <h2>
                <Link
                  to={`/blog/${post.slug}`}
                  onClick={() =>
                    trackEvent("blog_post_click", {
                      slug: post.slug,
                      title: post.title,
                    })
                  }
                >
                  {post.title}
                </Link>
              </h2>

              <p>{post.description}</p>

              <Link
                to={`/blog/${post.slug}`}
                className="blog-read-more"
                onClick={() =>
                  trackEvent("blog_post_click", {
                    slug: post.slug,
                    title: post.title,
                  })
                }
              >
                Read article →
              </Link>
            </article>
          ))}
        </section>
      </main>
    </>
  );
};

export default BlogPage;
